import React, { useEffect, useRef, useState } from 'react';
import propTypes from 'prop-types';
import { Button } from 'reactstrap';
import ModalStartReturn from './Processed/Modals/ModalStartReturn';
import { isReturnStartEligible } from './saleReturnEligibility';
import { readSaleReturn, returnErrorMessage } from '../Returns/returnSale';

const StartReturnButton = ({ sale, startReturn, onStarted }) => {
  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const pending = useRef(false);
  const mounted = useRef(true);
  useEffect(() => () => { mounted.current = false; }, []);
  const started = readSaleReturn(sale).record != null;

  const submit = async (awb) => {
    if (pending.current || started || !isReturnStartEligible(sale)) return;
    pending.current = true;
    setSubmitting(true);
    setError(null);
    try {
      const result = await startReturn(sale.id, { awb_number: awb });
      if (!mounted.current) return;
      if (!result || !result.ok) {
        setError(returnErrorMessage(result && result.error));
        return;
      }
      const payload = result.data && result.data.data;
      const record = payload && (payload.sale_return || payload.saleReturn);
      onStarted(record || { status: 'OUTSTANDING' });
      setOpen(false);
    } catch (err) {
      if (mounted.current) setError(returnErrorMessage(err));
    } finally {
      pending.current = false;
      if (mounted.current) setSubmitting(false);
    }
  };

  if (!isReturnStartEligible(sale)) return null;
  return <>
    <Button color="primary" size="sm" disabled={started || submitting}
      title={started ? 'Return already started' : 'Start Return'}
      onClick={() => { setError(null); setOpen(true); }}>Start Return</Button>
    <ModalStartReturn isOpen={open} sale={sale} isSubmitting={submitting} error={error}
      onCancel={() => { if (!pending.current) setOpen(false); }} onSubmit={submit} />
  </>;
};

StartReturnButton.propTypes = {
  sale: propTypes.object.isRequired,
  startReturn: propTypes.func.isRequired,
  onStarted: propTypes.func.isRequired,
};
export default StartReturnButton;
